var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import Input from '@/components/Input.vue';
import { getAccountPreferences, updateAccount } from '@/clients/admin';
import { NotificationService } from '@/services/NotificationService';
let AccountManagementAccountInfoForm = class AccountManagementAccountInfoForm extends Vue {
    constructor() {
        super(...arguments);
        this.account = {
            id: '',
            allowed_users: '',
            email: '',
            name: '',
            account_type: '',
            skip_origin_check: '',
            superlogica_id: '',
            stripe_id: '',
            plan_name: '',
            phone_number: '',
            country: '',
            state: '',
            city: '',
            neighborhood: '',
            street: '',
            complemental_address: '',
        };
        this.loading = false;
        this.onlyInDatabase = false;
        this.enableAccountID = false;
        this.confirm = false;
        this.alertRefButton = '';
    }
    async mounted() {
        const accountId = this.$store.getters['admin/get_selected_account'];
        const response = await getAccountPreferences(accountId);
        this.account = response.data;
    }
    confirmEditButton() {
        this.enableAccountID = !this.enableAccountID;
        const ref = this.alertRefButton;
        setTimeout(() => {
            // @ts-ignore TS2349: property inexistent
            this.$nextTick(() => this.$refs[ref].focus());
        }, 100);
    }
    handleAlert(ref) {
        this.alertRefButton = ref;
        if (this.enableAccountID) {
            this.enableAccountID = false;
        }
        else {
            this.confirm = true;
        }
    }
    get textAlert() {
        if (this.alertRefButton == 'superlogicaAccID') {
            return `
        Essa informação é extremamente delicada e alterá-la pode prejudicar o 
        usuário, deseja continuar?
      `;
        }
        else {
            return `
        Adicionar um id de customer do stripe vai fazer com que todas as operações
        de assinatura e pagamento do usuário passem para o stripe, deseja continuar?
      `;
        }
    }
    async confirmChanges() {
        this.loading = true;
        const payload = {
            ...this.account,
            superlogica_account_id: this.account.superlogica_id,
            customer_id: this.account.stripe_id,
            only_in_database: this.onlyInDatabase,
        };
        this.loading = true;
        try {
            await updateAccount(this.account.id, payload);
            NotificationService.success('Sucesso', 'Conta atualizada com sucesso!');
        }
        catch (e) {
            NotificationService.error('Erro', 'Aconteceu algo inesperado no processo de atualização das informações da conta');
        }
        this.loading = false;
    }
};
AccountManagementAccountInfoForm = __decorate([
    Component({
        components: {
            Input,
        },
    })
], AccountManagementAccountInfoForm);
export default AccountManagementAccountInfoForm;
